// Polish

const lang = {
  gateMediaPreviewHeader: 'Może Cię również zainteresuje',
  loadmore: 'Pokaż więcej',
  nextMedia: 'Następny materiał',
  previousMedia: 'Poprzedni materiał',
  closePost: 'Zamknij wpis',
  nextPost: 'Następny wpis',
  previousPost: 'Poprzedni wpis',
  outOfStock: 'Niedostępny',
  numberOfReviews(n) {
    if (n % 10 === 1 && n % 100 !== 11) {
      return 'opinia'
    }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'opinie' : 'opinii'
  },
  reportFormField: 'Proszę wpisać wiadomość',
  reportPost: 'Zgłoś treść',
  reportFormTitle: 'Czy chcesz zgłosić ten obraz?',
  reportFormDetails:
    'Jeśli uważasz, że obraz jest nieodpowiedni, nielegalny lub narusza czyjeś prawa, możesz to zgłosić. Jeśli zgłosisz obraz / tekst, moderatorzy treści zostaną o tym powiadomieni i zostaną podjęte odpowiednie działania.',
  reportFormMessagePlaceholder: 'Podaj powód zgłoszenia',
  reportFormMessageLabel: 'Wiadomość',
  reportFormEmailLabel: 'Twój e-mail',
  reportFormSubmitButtonText: 'Wyślij zgłoszenie',
  reportFormCancelButtonText: 'Anuluj',
  reportFormSentTitle: 'Dziękujemy za Twój raport!',
  reportFormSentCloseButtonText: 'Zamknij',
  cardAndTileAriaLabel: 'Lista postów z kont na różnych platformach społecznościowych',
  carouselAriaLabel: 'Karuzela z postami z kont na różnych platformach społecznościowych',
  singleAriaLabel: 'Poniżej publikacja z konta w mediach społecznościowych',
  poweredBy: 'Technologia Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` opublikowane w dniu ${date}` : ''
    const createdByString = userName ? ` użytkownika ${userName}` : ''
    return `Zdjęcie${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Prześlij swoje multimedia',
  openTheGate: 'Otwórz okno dialogowe',
  gridRoleDescription: 'siatka',
  carouselRoleDescription: 'karuzela',
  tiktokVideoAriaLabel: 'Osadzony film TikTok. Naciśnij odtwarzanie, aby zobaczyć zawartość.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Miniatura mediów ${postIndex + 1} z ${maxPosts}, otwiera dialog z zawartością mediów społecznościowych i listą wyróżnionych produktów.`,
  carouselControlButtonsAriaLabel: 'Przyciski sterowania karuzelą',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) => `Media ${mediaIndex + 1} z ${maxMedia}`,
  showMoreCaption: 'Pokaż więcej podpisu',
  showLessCaption: 'Pokaż mniej podpisu',
  originalPrice: (price) => `Cena oryginalna: ${price}`,
  salesPrice: (price) => `Cena promocyjna: ${price}`,
  postPublishedBy: 'Post opublikowany przez',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Wideo' : 'Obraz'
    const user = username ? `${username}` : 'nieznany użytkownik'
    const publishDate = date ? `w dniu ${date}` : ''
    return `${mediaType} opublikowane przez ${user} ${publishDate}. Może to być ${altText}`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Wpis ${postIndex + 1} z ${maxPosts}.`,
}

export default lang
